import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { LookupItemForProcessingResult } from "./item-processing";

export const lookupItemForProcessing = {
  name: "lookupItemForProcessing" as const,
  input: z.object({
    identifier: z.string().min(1).max(255),
    locationId: locationIdFormat.schema,
    sourceReceivingBinId: storageLocationIdFormat.schema.optional(),
  }),
  output: z.object({ result: LookupItemForProcessingResult }),
};
